export const entitlementReducer = (state = null, action) => (action.type === 'SET_ENTITLEMENT' ? action.entitlement : state);
